
// PAQUETES
import React, { useEffect, useMemo, useState } from "react";



export async function slugify(texto = "") {
  return texto
  .toString()
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // sin tildes
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9]+/g, "-") // espacios/símbolos -> -
  .replace(/^-+|-+$/g, "");    // sin - al inicio/fin
}


export function estrellas(cant) {
  const n = Math.max(1, Math.min(5, Number(cant || 0))); // limiamos el valor entre 1 y 5
  return "★".repeat(n) + "☆".repeat(5 - n); // convertimos en estrellas pero string
}




  // Normaliza el resumen para que la UI siempre reciba: { cantidad, valoracionFinal, cantidadEstrellas }
export function normalizarResumen({ resumenServicio, resumenReseñas } = {}) {
  // 1) Preferimos el formato nuevo del servicio: servicio.resumenReseñas {promedio,total,ultima}
  if (resumenReseñas && (resumenReseñas.total !== undefined || resumenReseñas.promedio !== undefined)) {
    const promedio = Number(resumenReseñas.promedio || 0);
    const total = Number(resumenReseñas.total || 0);
    const estrellas = Math.max(0, Math.min(5, Math.round(promedio)));
    return { cantidad: total, valoracionFinal: Number(promedio.toFixed(1)), cantidadEstrellas: estrellas };
  }

  // 2) Fallback al formato viejo: {cantidad, valoracionFinal, cantidadEstrellas}
  if (resumenServicio && (resumenServicio.cantidad !== undefined || resumenServicio.valoracionFinal !== undefined)) {
    return {
      cantidad: Number(resumenServicio.cantidad || 0),
      valoracionFinal: Number(resumenServicio.valoracionFinal || 0),
      cantidadEstrellas: Number(resumenServicio.cantidadEstrellas || 0),
    };
  }

  return { cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 };
}